import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function BottomCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20flat%20lay%20fashion%20products%20on%20warm%20neutral%20background%2C%20sneakers%20bags%20accessories%20arranged%20in%20diagonal%20composition%2C%20soft%20dramatic%20lighting%2C%20editorial%20product%20photography%2C%20cinematic%20mood%2C%20high%20detail%20textures&width=1600&height=800&seq=bottomcta-bg-01&orientation=landscape"
          alt="YOYBUY fashion"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-stone-900/75" />
      </div>

      {/* Floating product images */}
      <div className="absolute left-6 top-10 md:left-16 md:top-16 w-20 h-20 md:w-32 md:h-32 rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl rotate-6 opacity-70 hidden md:block">
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20sneaker%20product%20photography%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20crisp%20shadows%2C%20high%20detail&width=300&height=300&seq=bottomcta-float-01&orientation=squarish"
          alt="product"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute right-8 top-16 md:right-20 md:top-20 w-16 h-16 md:w-24 md:h-24 rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl -rotate-3 opacity-60 hidden md:block">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20handbag%20product%20photography%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20shadows%2C%20high%20detail&width=250&height=250&seq=bottomcta-float-02&orientation=squarish"
          alt="product"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute right-16 bottom-12 md:right-32 md:bottom-16 w-18 h-18 md:w-28 md:h-28 rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl rotate-12 opacity-65 hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=Designer%20watch%20product%20photography%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20premium%20lighting%2C%20high%20detail&width=280&height=280&seq=bottomcta-float-03&orientation=squarish"
          alt="product"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Decorative blurred elements */}
      <div className="absolute top-16 left-1/3 w-48 h-48 bg-rose-300/15 rounded-full blur-3xl" />
      <div className="absolute bottom-8 right-1/4 w-56 h-56 bg-amber-300/10 rounded-full blur-3xl" />

      <div className="relative z-10 w-full px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-4 py-1.5 bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium rounded-full mb-6">
            {t('bottomCta.title')}
          </span>

          <h2 className="font-heading text-3xl md:text-5xl font-medium text-white leading-tight">
            {t('bottomCta.subtitle')}
          </h2>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-stone-900 text-sm font-semibold rounded-full hover:bg-stone-100 transition-colors whitespace-nowrap shadow-lg shadow-black/20"
            >
              yoybuy sheet
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm font-semibold rounded-full hover:bg-white/25 transition-colors whitespace-nowrap"
            >
              buy it now
              <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}